// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../nprogress/nprogress.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../sweetalert2/dist/sweetalert2.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../@fortawesome/fontawesome-free/css/all.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../tingle.js/dist/tingle.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../cropperjs/dist/cropper.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Image Picker */

.password-str-bar ~ .invalid-feedback {
  margin-top: -20px;
}

.tingle-modal--visible {
  z-index: 10000;
}

@media (max-width: 540px) {
  .tingle-modal-box__footer .tingle-btn.tingle-btn--danger {
	display:none;
  }
  
  .tingle-modal-box__content {
	padding: 1.5rem 3rem;
  }

  .tingle-modal-box {
	width: 100%;
  }

  .price_in {
	margin-bottom: 24px;
  }
}

.tingle-modal.tingle-modal--visible {
  display: flex;
  flex-direction: column;
}

.tingle-modal-box {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.tingle-modal-box__content {
  flex: 1 1;
  position: relative;
}

.tingle-modal-box__content > div {
  position: absolute;
  left:0;
  right:0;
  top:0;
  bottom:0;
}

.tingle-modal--overflow {
  overflow-y: hidden !important;
  padding-top: 0 !important;
}

.tingle-modal-box__footer {
  text-align: center;
}

.back-btn-shown {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background-color: black;
  border: 1px solid white;
  box-shadow: 0 10px 30px rgba(82, 85, 90, 0.2);
  color: white;
  text-align: center;
  cursor: pointer;
  line-height: 25px;
  font-size: 20px;
}

.back-btn-shown span {
  display: none;
}

.back-btn-shown:hover span {
  position: absolute;
  top: 0;
  right: 35px;
  width: 74px;
  margin-left: -37px;
  display: block;
  background-color: black;
  color: white;
  font-size: 12px;
  border: 1px solid black;
  box-shadow: 0 10px 40px rgba(82, 85, 90, 0.2);
}


.step {
    position: relative;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-right: calc(1.5rem / -2);
    margin-left: calc(1.5rem / -2)
}

.step.step-dashed .step-icon::after {
    border-left-style: dashed
}

.step-icon-border {
    border: .125rem solid rgba(231,234,243,.7)
}

.step-title {
    display: block;
    /*color: #1e2022;*/
    color: var(--bs-dark);
    
    font-weight: 600
}

.step-text:last-child {
    color: #677788;
    margin-bottom: 0
}

.step-border-last-0 .step-item:last-child .step-icon::after {
    display: none
}

.step .step-item {
    display: flex;
    flex-direction: column;
    flex-basis: 0;
    flex: 0 0 100%;
    max-width: 100%;
    padding-right: .75rem;
    padding-left: .75rem;
    margin-bottom: 2.25rem
}

.step-item-between .step-item:last-child {
    flex: 0 0 auto;
    width: auto
}

.step .step-content-wrapper {
    position: relative;
    display: flex;
    width: 100%
}

.step .step-content {
    flex: 1 1
}

.step-item.collapse:not(.show) {
    display: none
}

.step-item .step-title-description {
    display: none
}

.step-item.focus .step-title-description {
    display: block
}

.step .step-avatar {
    font-size: .875rem;
    font-weight: 600;
    width: 2.625rem;
    height: 2.625rem;
    border-radius: 50%;
    margin-right: 1rem
}

.step .step-avatar-img {
    max-width: 100%;
    height: auto;
    border-radius: 50%
}

.step .step-avatar::after {
    position: absolute;
    top: 3.375rem;
    left: 1.3125rem;
    height: calc(100% - 1.875rem);
    border-left: .125rem solid rgba(231,234,243,.7);
    content: ""
}

.step-avatar-xs .step-avatar,.step-avatar-xs.step-avatar {
    font-size: .65625rem;
    width: 1.53125rem;
    height: 1.53125rem
}

.step-avatar-xs .step-avatar::after,.step-avatar-xs.step-avatar::after {
    top: 2.28125rem;
    left: .70312rem;
    width: 1.625rem;
    height: calc(100% - .78125rem)
}

.step-avatar-xs .step-divider::after {
    left: .76562rem
}

.step-avatar-sm .step-avatar,.step-avatar-sm.step-avatar {
    font-size: .875rem;
    width: 2.40625rem;
    height: 2.40625rem
}

.step-avatar-sm .step-avatar::after,.step-avatar-sm.step-avatar::after {
    top: 3.15625rem;
    left: 1.14062rem;
    width: 1.625rem;
    height: calc(100% - 1.65625rem)
}

.step-avatar-sm .step-divider::after {
    left: 1.20312rem
}

.step-avatar-lg .step-avatar,.step-avatar-lg.step-avatar {
    font-size: 1rem;
    width: 4.8125rem;
    height: 4.8125rem
}

.step-avatar-lg .step-avatar::after,.step-avatar-lg.step-avatar::after {
    top: 5.5625rem;
    left: 2.34375rem;
    width: 1.625rem;
    height: calc(100% - 4.0625rem)
}

.step-avatar-lg .step-divider::after {
    left: 2.40625rem
}

.step-divider {
    display: inline-flex;
    align-items: center;
    text-transform: uppercase;
    height: 1rem;
    font-size: .71094rem;
    font-weight: 600
}

.step-divider::after {
    position: absolute;
    top: 1.75rem;
    left: 1.3125rem;
    height: calc(100% - .25rem);
    border-left: .125rem solid rgba(231,234,243,.7);
    content: ""
}

.step .step-icon {
    display: inline-flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    font-size: .875rem;
    font-weight: 600;
    width: 2.625rem;
    height: 2.625rem;
    border-radius: 50%;
    margin-right: 1rem
}

.step .step-icon::after {
    position: absolute;
    top: 3.375rem;
    left: 1.3125rem;
    height: calc(100% - 1.875rem);
    border-left: .125rem solid rgba(231,234,243,.7);
    content: ""
}

.step .step-icon-pseudo::before {
    display: block;
    width: .25rem;
    height: .25rem;
    background-color: #97a4af;
    border-radius: 50%;
    content: ""
}

.step-icon-xs .step-icon,.step-icon-xs.step-icon {
    font-size: .65625rem;
    width: 1.53125rem;
    height: 1.53125rem
}

.step-icon-xs .step-icon::after,.step-icon-xs.step-icon::after {
    top: 2.28125rem;
    left: .70312rem;
    width: 1.625rem;
    height: calc(100% - .78125rem)
}

.step-icon-xs .step-divider::after {
    left: .76562rem
}

.step-icon-sm .step-icon,.step-icon-sm.step-icon {
    font-size: .875rem;
    width: 2.40625rem;
    height: 2.40625rem
}

.step-icon-sm .step-icon::after,.step-icon-sm.step-icon::after {
    top: 3.15625rem;
    left: 1.14062rem;
    width: 1.625rem;
    height: calc(100% - 1.65625rem)
}

.step-icon-sm .step-divider::after {
    left: 1.20312rem
}

.step-icon-lg .step-icon,.step-icon-lg.step-icon {
    font-size: 1rem;
    width: 4.8125rem;
    height: 4.8125rem
}

.step-icon-lg .step-icon::after,.step-icon-lg.step-icon::after {
    top: 5.5625rem;
    left: 2.34375rem;
    width: 1.625rem;
    height: calc(100% - 4.0625rem)
}

.step-icon-lg .step-divider::after {
    left: 2.40625rem
}

@media (min-width: 576px) {
    .step-sm.step-dashed .step-icon::after {
        border-left:none;
        border-top-style: dashed
    }

    .step-sm .step-item {
        flex-grow: 1;
        flex: 1 1;
        margin-bottom: 0
    }

    .step-sm:not(.step-inline) .step-content-wrapper {
        display: block
    }

    .step-sm .step-icon {
        margin-bottom: 1rem
    }

    .step-sm .step-icon::after {
        top: 1.3125rem;
        left: 4.125rem;
        width: calc(100% - 4.125rem);
        height: 1.625rem;
        border-top: .125rem solid rgba(231,234,243,.7);
        border-left: none
    }

    .step-sm .step-icon.step-icon-xs::after,.step-sm.step-icon-xs .step-icon::after {
        top: .76562rem;
        left: 3.03125rem;
        width: calc(100% - 3.03125rem)
    }

    .step-sm .step-icon.step-icon-sm::after,.step-sm.step-icon-sm .step-icon::after {
        top: 1.20312rem;
        left: 3.90625rem;
        width: calc(100% - 3.90625rem)
    }

    .step-sm .step-icon.step-icon-lg::after,.step-sm.step-icon-lg .step-icon::after {
        top: 2.40625rem;
        left: 6.3125rem;
        width: calc(100% - 6.3125rem)
    }
}

@media (min-width: 768px) {
    .step-md.step-dashed .step-icon::after {
        border-left:none;
        border-top-style: dashed
    }

    .step-md .step-item {
        flex-grow: 1;
        flex: 1 1;
        margin-bottom: 0
    }

    .step-md:not(.step-inline) .step-content-wrapper {
        display: block
    }

    .step-md .step-icon {
        margin-bottom: 1rem
    }

    .step-md .step-icon::after {
        top: 1.3125rem;
        left: 4.125rem;
        width: calc(100% - 4.125rem);
        height: 1.625rem;
        border-top: .125rem solid rgba(231,234,243,.7);
        border-left: none
    }

    .step-md .step-icon.step-icon-xs::after,.step-md.step-icon-xs .step-icon::after {
        top: .76562rem;
        left: 3.03125rem;
        width: calc(100% - 3.03125rem)
    }

    .step-md .step-icon.step-icon-sm::after,.step-md.step-icon-sm .step-icon::after {
        top: 1.20312rem;
        left: 3.90625rem;
        width: calc(100% - 3.90625rem)
    }

    .step-md .step-icon.step-icon-lg::after,.step-md.step-icon-lg .step-icon::after {
        top: 2.40625rem;
        left: 6.3125rem;
        width: calc(100% - 6.3125rem)
    }
}

@media (min-width: 992px) {
    .step-lg.step-dashed .step-icon::after {
        border-left:none;
        border-top-style: dashed
    }

    .step-lg .step-item {
        flex-grow: 1;
        flex: 1 1;
        margin-bottom: 0
    }

    .step-lg:not(.step-inline) .step-content-wrapper {
        display: block
    }

    .step-lg .step-icon {
        margin-bottom: 1rem
    }

    .step-lg .step-icon::after {
        top: 1.3125rem;
        left: 4.125rem;
        width: calc(100% - 4.125rem);
        height: 1.625rem;
        border-top: .125rem solid rgba(231,234,243,.7);
        border-left: none
    }

    .step-lg .step-icon.step-icon-xs::after,.step-lg.step-icon-xs .step-icon::after {
        top: .76562rem;
        left: 3.03125rem;
        width: calc(100% - 3.03125rem)
    }

    .step-lg .step-icon.step-icon-sm::after,.step-lg.step-icon-sm .step-icon::after {
        top: 1.20312rem;
        left: 3.90625rem;
        width: calc(100% - 3.90625rem)
    }

    .step-lg .step-icon.step-icon-lg::after,.step-lg.step-icon-lg .step-icon::after {
        top: 2.40625rem;
        left: 6.3125rem;
        width: calc(100% - 6.3125rem)
    }
}

@media (min-width: 1200px) {
    .step-xl.step-dashed .step-icon::after {
        border-left:none;
        border-top-style: dashed
    }

    .step-xl .step-item {
        flex-grow: 1;
        flex: 1 1;
        margin-bottom: 0
    }

    .step-xl:not(.step-inline) .step-content-wrapper {
        display: block
    }

    .step-xl .step-icon {
        margin-bottom: 1rem
    }

    .step-xl .step-icon::after {
        top: 1.3125rem;
        left: 4.125rem;
        width: calc(100% - 4.125rem);
        height: 1.625rem;
        border-top: .125rem solid rgba(231,234,243,.7);
        border-left: none
    }

    .step-xl .step-icon.step-icon-xs::after,.step-xl.step-icon-xs .step-icon::after {
        top: .76562rem;
        left: 3.03125rem;
        width: calc(100% - 3.03125rem)
    }

    .step-xl .step-icon.step-icon-sm::after,.step-xl.step-icon-sm .step-icon::after {
        top: 1.20312rem;
        left: 3.90625rem;
        width: calc(100% - 3.90625rem)
    }

    .step-xl .step-icon.step-icon-lg::after,.step-xl.step-icon-lg .step-icon::after {
        top: 2.40625rem;
        left: 6.3125rem;
        width: calc(100% - 6.3125rem)
    }
}

@media (min-width: 576px) {
    .step-sm.step-centered {
        text-align:center
    }

    .step-sm.step-centered .step-item:last-child .step-icon::after {
        display: none
    }

    .step-sm.step-centered .step-icon {
        margin-left: auto;
        margin-right: auto
    }

    .step-sm.step-centered .step-icon::after {
        width: calc(100% - 4.125rem);
        left: calc(50% + 2.8125rem)
    }

    .step-sm.step-centered .step-icon.step-icon-xs::after,.step-sm.step-centered.step-icon-xs .step-icon::after {
        width: calc(100% - 3.03125rem);
        left: calc(50% + 2.26562rem)
    }

    .step-sm.step-centered .step-icon.step-icon-sm::after,.step-sm.step-centered.step-icon-sm .step-icon::after {
        width: calc(100% - 3.90625rem);
        left: calc(50% + 2.70312rem)
    }

    .step-sm.step-centered .step-icon.step-icon-lg::after,.step-sm.step-centered.step-icon-lg .step-icon::after {
        width: calc(100% - 6.3125rem);
        left: calc(50% + 3.90625rem)
    }
}

@media (min-width: 768px) {
    .step-md.step-centered {
        text-align:center
    }

    .step-md.step-centered .step-item:last-child .step-icon::after {
        display: none
    }

    .step-md.step-centered .step-icon {
        margin-left: auto;
        margin-right: auto
    }

    .step-md.step-centered .step-icon::after {
        width: calc(100% - 4.125rem);
        left: calc(50% + 2.8125rem)
    }

    .step-md.step-centered .step-icon.step-icon-xs::after,.step-md.step-centered.step-icon-xs .step-icon::after {
        width: calc(100% - 3.03125rem);
        left: calc(50% + 2.26562rem)
    }

    .step-md.step-centered .step-icon.step-icon-sm::after,.step-md.step-centered.step-icon-sm .step-icon::after {
        width: calc(100% - 3.90625rem);
        left: calc(50% + 2.70312rem)
    }

    .step-md.step-centered .step-icon.step-icon-lg::after,.step-md.step-centered.step-icon-lg .step-icon::after {
        width: calc(100% - 6.3125rem);
        left: calc(50% + 3.90625rem)
    }
}

@media (min-width: 992px) {
    .step-lg.step-centered {
        text-align:center
    }

    .step-lg.step-centered .step-item:last-child .step-icon::after {
        display: none
    }

    .step-lg.step-centered .step-icon {
        margin-left: auto;
        margin-right: auto
    }

    .step-lg.step-centered .step-icon::after {
        width: calc(100% - 4.125rem);
        left: calc(50% + 2.8125rem)
    }

    .step-lg.step-centered .step-icon.step-icon-xs::after,.step-lg.step-centered.step-icon-xs .step-icon::after {
        width: calc(100% - 3.03125rem);
        left: calc(50% + 2.26562rem)
    }

    .step-lg.step-centered .step-icon.step-icon-sm::after,.step-lg.step-centered.step-icon-sm .step-icon::after {
        width: calc(100% - 3.90625rem);
        left: calc(50% + 2.70312rem)
    }

    .step-lg.step-centered .step-icon.step-icon-lg::after,.step-lg.step-centered.step-icon-lg .step-icon::after {
        width: calc(100% - 6.3125rem);
        left: calc(50% + 3.90625rem)
    }
}

@media (min-width: 992px) {
    .step-lg.step-centered {
        text-align:center
    }

    .step-lg.step-centered .step-item:last-child .step-icon::after {
        display: none
    }

    .step-lg.step-centered .step-icon {
        margin-left: auto;
        margin-right: auto
    }

    .step-lg.step-centered .step-icon::after {
        width: calc(100% - 4.125rem);
        left: calc(50% + 2.8125rem)
    }

    .step-lg.step-centered .step-icon.step-icon-xs::after,.step-lg.step-centered.step-icon-xs .step-icon::after {
        width: calc(100% - 3.03125rem);
        left: calc(50% + 2.26562rem)
    }

    .step-lg.step-centered .step-icon.step-icon-sm::after,.step-lg.step-centered.step-icon-sm .step-icon::after {
        width: calc(100% - 3.90625rem);
        left: calc(50% + 2.70312rem)
    }

    .step-lg.step-centered .step-icon.step-icon-lg::after,.step-lg.step-centered.step-icon-lg .step-icon::after {
        width: calc(100% - 6.3125rem);
        left: calc(50% + 3.90625rem)
    }
}

.step .step-is-invalid-icon,.step .step-is-valid-icon {
    display: none
}

.step .active .step-icon,.step .active.is-valid .step-icon,.step .visited .step-icon {
    color: #fff;
    background-color: var(--bs-primary)
}

.step .active .step-title,.step .active.is-valid .step-title,.step .visited .step-title {
    color: var(--bs-primary)
}

.step .is-valid .step-icon {
    color: #fff;
    background-color: #377dff
}

.step .is-valid .step-title {
    color: var(--bs-primary)
}

.step .is-valid .step-is-valid-icon {
    display: inline-flex
}

.step .is-valid .step-is-default-icon,.step .is-valid .step-is-invalid-icon {
    display: none
}

.step .is-invalid .step-icon {
    color: #fff;
    background-color: var(--bs-danger)
}

.step .is-invalid .step-title {
    color: var(--bs-danger)
}

.step .is-invalid .step-is-invalid-icon {
    display: inline-flex
}

.step .is-invalid .step-is-default-icon,.step .is-invalid .step-is-valid-icon {
    display: none
}

.step-icon-primary {
    color: #fff;
    background-color: #377dff
}

.step-icon-primary.step-icon-pseudo::before {
    background-color: #fff
}

.step-icon-secondary {
    color: #fff;
    background-color: #71869d
}

.step-icon-secondary.step-icon-pseudo::before {
    background-color: #fff
}

.step-icon-success {
    color: #fff;
    background-color: #00c9a7
}

.step-icon-success.step-icon-pseudo::before {
    background-color: #fff
}

.step-icon-info {
    color: #fff;
    background-color: #09a5be
}

.step-icon-info.step-icon-pseudo::before {
    background-color: #fff
}

.step-icon-warning {
    color: #000;
    background-color: #f5ca99
}

.step-icon-warning.step-icon-pseudo::before {
    background-color: #000
}

.step-icon-danger {
    color: #fff;
    background-color: #ed4c78
}

.step-icon-danger.step-icon-pseudo::before {
    background-color: #fff
}

.step-icon-light {
    color: #000;
    background-color: #f9fafc
}

.step-icon-light.step-icon-pseudo::before {
    background-color: #000
}

.step-icon-dark {
    color: #fff;
    background-color: #132144
}

.step-icon-dark.step-icon-pseudo::before {
    background-color: #fff
}

.step-icon-soft-primary {
    color: #377dff;
    background-color: rgba(55,125,255,.1)
}

.step-icon-soft-primary.step-icon-pseudo::before {
    background-color: #377dff
}

.step-icon-soft-secondary {
    color: #71869d;
    background-color: rgba(113,134,157,.1)
}

.step-icon-soft-secondary.step-icon-pseudo::before {
    background-color: #71869d
}

.step-icon-soft-success {
    color: #00c9a7;
    background-color: rgba(0,201,167,.1)
}

.step-icon-soft-success.step-icon-pseudo::before {
    background-color: #00c9a7
}

.step-item {
  cursor: pointer;
}

.step-icon-soft-info {
    color: #09a5be;
    background-color: rgba(9,165,190,.1)
}

.step-icon-soft-info.step-icon-pseudo::before {
    background-color: #09a5be
}

.step-icon-soft-warning {
    color: #f5ca99;
    background-color: rgba(245,202,153,.1)
}

.step-icon-soft-warning.step-icon-pseudo::before {
    background-color: #f5ca99
}

.step-icon-soft-danger {
    color: #ed4c78;
    background-color: rgba(237,76,120,.1)
}

.step-icon-soft-danger.step-icon-pseudo::before {
    background-color: #ed4c78
}

.step-icon-soft-light {
    color: #f9fafc;
    background-color: rgba(249,250,252,.1)
}

.step-icon-soft-light.step-icon-pseudo::before {
    background-color: #f9fafc
}

.step-icon-soft-dark {
    color: var(--bs-dark);
    background-color: var(--bs-light)
}

.step-icon-soft-dark.step-icon-pseudo::before {
    background-color: var(--bs-light)
}

.step-inline .step-content-wrapper {
    align-items: center
}

.step-inline .step-item:last-child .step-title::after {
    display: none
}

.step-inline .step-title {
    display: inline-block
}

@media (min-width: 576px) {
    .step-sm.step-inline.step-dashed .step-title::after {
        border-top-style:dashed
    }

    .step-sm.step-inline .step-item {
        overflow: hidden
    }

    .step-sm.step-inline .step-icon {
        margin-bottom: 0
    }

    .step-sm.step-inline .step-icon::after {
        display: none
    }

    .step-sm.step-inline .step-title::after {
        position: absolute;
        top: 1.3125rem;
        width: 100%;
        height: 1.625rem;
        border-top: .125rem solid rgba(231,234,243,.7);
        margin-left: 1.5rem;
        content: ""
    }

    .step-sm.step-inline .step-icon-xs+.step-content .step-title::after,.step-sm.step-inline.step-icon-xs .step-content .step-title::after {
        top: .76562rem
    }

    .step-sm.step-inline .step-icon-sm+.step-content .step-title::after,.step-sm.step-inline.step-icon-sm .step-content .step-title::after {
        top: 1.20312rem
    }

    .step-sm.step-inline .step-icon-lg+.step-content .step-title::after,.step-sm.step-inline.step-icon-lg .step-content .step-title::after {
        top: 2.40625rem
    }
}

@media (min-width: 768px) {
    .step-md.step-inline.step-dashed .step-title::after {
        border-top-style:dashed
    }

    .step-md.step-inline .step-item {
        overflow: hidden
    }

    .step-md.step-inline .step-icon {
        margin-bottom: 0
    }

    .step-md.step-inline .step-icon::after {
        display: none
    }

    .step-md.step-inline .step-title::after {
        position: absolute;
        top: 1.3125rem;
        width: 100%;
        height: 1.625rem;
        border-top: .125rem solid rgba(231,234,243,.7);
        margin-left: 1.5rem;
        content: ""
    }

    .step-md.step-inline .step-icon-xs+.step-content .step-title::after,.step-md.step-inline.step-icon-xs .step-content .step-title::after {
        top: .76562rem
    }

    .step-md.step-inline .step-icon-sm+.step-content .step-title::after,.step-md.step-inline.step-icon-sm .step-content .step-title::after {
        top: 1.20312rem
    }

    .step-md.step-inline .step-icon-lg+.step-content .step-title::after,.step-md.step-inline.step-icon-lg .step-content .step-title::after {
        top: 2.40625rem
    }
}

@media (min-width: 992px) {
    .step-lg.step-inline.step-dashed .step-title::after {
        border-top-style:dashed
    }

    .step-lg.step-inline .step-item {
        overflow: hidden
    }

    .step-lg.step-inline .step-icon {
        margin-bottom: 0
    }

    .step-lg.step-inline .step-icon::after {
        display: none
    }

    .step-lg.step-inline .step-title::after {
        position: absolute;
        top: 1.3125rem;
        width: 100%;
        height: 1.625rem;
        border-top: .125rem solid rgba(231,234,243,.7);
        margin-left: 1.5rem;
        content: ""
    }

    .step-lg.step-inline .step-icon-xs+.step-content .step-title::after,.step-lg.step-inline.step-icon-xs .step-content .step-title::after {
        top: .76562rem
    }

    .step-lg.step-inline .step-icon-sm+.step-content .step-title::after,.step-lg.step-inline.step-icon-sm .step-content .step-title::after {
        top: 1.20312rem
    }

    .step-lg.step-inline .step-icon-lg+.step-content .step-title::after,.step-lg.step-inline.step-icon-lg .step-content .step-title::after {
        top: 2.40625rem
    }
}

@media (min-width: 1200px) {
    .step-xl.step-inline.step-dashed .step-title::after {
        border-top-style:dashed
    }

    .step-xl.step-inline .step-item {
        overflow: hidden
    }

    .step-xl.step-inline .step-icon {
        margin-bottom: 0
    }

    .step-xl.step-inline .step-icon::after {
        display: none
    }

    .step-xl.step-inline .step-title::after {
        position: absolute;
        top: 1.3125rem;
        width: 100%;
        height: 1.625rem;
        border-top: .125rem solid rgba(231,234,243,.7);
        margin-left: 1.5rem;
        content: ""
    }

    .step-xl.step-inline .step-icon-xs+.step-content .step-title::after,.step-xl.step-inline.step-icon-xs .step-content .step-title::after {
        top: .76562rem
    }

    .step-xl.step-inline .step-icon-sm+.step-content .step-title::after,.step-xl.step-inline.step-icon-sm .step-content .step-title::after {
        top: 1.20312rem
    }

    .step-xl.step-inline .step-icon-lg+.step-content .step-title::after,.step-xl.step-inline.step-icon-lg .step-content .step-title::after {
        top: 2.40625rem
    }
}

@media (min-width: 576px) {
    .step-timeline-sm {
        margin-left:0;
        margin-right: 0
    }

    .step-timeline-sm .step-item {
        flex: 0 0 50%;
        max-width: 50%;
        padding-left: 0;
        padding-right: 0;
        margin-left: 50%
    }

    .step-timeline-sm .step-item:nth-child(even) {
        flex-direction: row-reverse;
        text-align: right;
        margin-left: auto;
        margin-right: 50%
    }

    .step-timeline-sm .step-item:nth-child(even) .step-content-wrapper {
        flex-direction: row-reverse
    }

    .step-timeline-sm .step-item:nth-child(even) .step-icon {
        margin-left: 0;
        margin-right: -1.3125rem
    }

    .step-timeline-sm .step-item:nth-child(even) .step-icon-xs {
        margin-right: -.76562rem
    }

    .step-timeline-sm .step-item:nth-child(even) .step-icon-sm {
        margin-right: -1.20312rem
    }

    .step-timeline-sm .step-item:nth-child(even) .step-icon-lg {
        margin-right: -2.40625rem
    }

    .step-timeline-sm .step-item:nth-child(even) .step-content {
        margin-right: 1.5rem
    }

    .step-timeline-sm .step-icon {
        margin-left: -1.3125rem
    }

    .step-timeline-sm .step-icon::after {
        left: auto;
        width: auto
    }

    .step-timeline-sm .step-icon-xs {
        margin-left: -.76562rem
    }

    .step-timeline-sm .step-icon-sm {
        margin-left: -1.20312rem
    }

    .step-timeline-sm .step-icon-lg {
        margin-left: -2.40625rem
    }
}

@media (min-width: 768px) {
    .step-timeline-md {
        margin-left:0;
        margin-right: 0
    }

    .step-timeline-md .step-item {
        flex: 0 0 50%;
        max-width: 50%;
        padding-left: 0;
        padding-right: 0;
        margin-left: 50%
    }

    .step-timeline-md .step-item:nth-child(even) {
        flex-direction: row-reverse;
        text-align: right;
        margin-left: auto;
        margin-right: 50%
    }

    .step-timeline-md .step-item:nth-child(even) .step-content-wrapper {
        flex-direction: row-reverse
    }

    .step-timeline-md .step-item:nth-child(even) .step-icon {
        margin-left: 0;
        margin-right: -1.3125rem
    }

    .step-timeline-md .step-item:nth-child(even) .step-icon-xs {
        margin-right: -.76562rem
    }

    .step-timeline-md .step-item:nth-child(even) .step-icon-sm {
        margin-right: -1.20312rem
    }

    .step-timeline-md .step-item:nth-child(even) .step-icon-lg {
        margin-right: -2.40625rem
    }

    .step-timeline-md .step-item:nth-child(even) .step-content {
        margin-right: 1.5rem
    }

    .step-timeline-md .step-icon {
        margin-left: -1.3125rem
    }

    .step-timeline-md .step-icon::after {
        left: auto;
        width: auto
    }

    .step-timeline-md .step-icon-xs {
        margin-left: -.76562rem
    }

    .step-timeline-md .step-icon-sm {
        margin-left: -1.20312rem
    }

    .step-timeline-md .step-icon-lg {
        margin-left: -2.40625rem
    }
}

@media (min-width: 992px) {
    .step-timeline-lg {
        margin-left:0;
        margin-right: 0
    }

    .step-timeline-lg .step-item {
        flex: 0 0 50%;
        max-width: 50%;
        padding-left: 0;
        padding-right: 0;
        margin-left: 50%
    }

    .step-timeline-lg .step-item:nth-child(even) {
        flex-direction: row-reverse;
        text-align: right;
        margin-left: auto;
        margin-right: 50%
    }

    .step-timeline-lg .step-item:nth-child(even) .step-content-wrapper {
        flex-direction: row-reverse
    }

    .step-timeline-lg .step-item:nth-child(even) .step-icon {
        margin-left: 0;
        margin-right: -1.3125rem
    }

    .step-timeline-lg .step-item:nth-child(even) .step-icon-xs {
        margin-right: -.76562rem
    }

    .step-timeline-lg .step-item:nth-child(even) .step-icon-sm {
        margin-right: -1.20312rem
    }

    .step-timeline-lg .step-item:nth-child(even) .step-icon-lg {
        margin-right: -2.40625rem
    }

    .step-timeline-lg .step-item:nth-child(even) .step-content {
        margin-right: 1.5rem
    }

    .step-timeline-lg .step-icon {
        margin-left: -1.3125rem
    }

    .step-timeline-lg .step-icon::after {
        left: auto;
        width: auto
    }

    .step-timeline-lg .step-icon-xs {
        margin-left: -.76562rem
    }

    .step-timeline-lg .step-icon-sm {
        margin-left: -1.20312rem
    }

    .step-timeline-lg .step-icon-lg {
        margin-left: -2.40625rem
    }
}

@media (min-width: 1200px) {
    .step-timeline-xl {
        margin-left:0;
        margin-right: 0
    }

    .step-timeline-xl .step-item {
        flex: 0 0 50%;
        max-width: 50%;
        padding-left: 0;
        padding-right: 0;
        margin-left: 50%
    }

    .step-timeline-xl .step-item:nth-child(even) {
        flex-direction: row-reverse;
        text-align: right;
        margin-left: auto;
        margin-right: 50%
    }

    .step-timeline-xl .step-item:nth-child(even) .step-content-wrapper {
        flex-direction: row-reverse
    }

    .step-timeline-xl .step-item:nth-child(even) .step-icon {
        margin-left: 0;
        margin-right: -1.3125rem
    }

    .step-timeline-xl .step-item:nth-child(even) .step-icon-xs {
        margin-right: -.76562rem
    }

    .step-timeline-xl .step-item:nth-child(even) .step-icon-sm {
        margin-right: -1.20312rem
    }

    .step-timeline-xl .step-item:nth-child(even) .step-icon-lg {
        margin-right: -2.40625rem
    }

    .step-timeline-xl .step-item:nth-child(even) .step-content {
        margin-right: 1.5rem
    }

    .step-timeline-xl .step-icon {
        margin-left: -1.3125rem
    }

    .step-timeline-xl .step-icon::after {
        left: auto;
        width: auto
    }

    .step-timeline-xl .step-icon-xs {
        margin-left: -.76562rem
    }

    .step-timeline-xl .step-icon-sm {
        margin-left: -1.20312rem
    }

    .step-timeline-xl .step-icon-lg {
        margin-left: -2.40625rem
    }
}

.react-select-container .react-select__control {
    background-color: var(--bs-form-select-bg);
    border-color: var(--bs-form-select-border-color);
    transition: none;
}

.react-select-container .react-select__control:hover {
    border-color: var(--bs-form-select-border-color);
}

.react-select-container .react-select__menu {
    background-color: var(--bs-form-select-bg);
    border: 1px solid var(--bs-form-select-border-color);
}

.react-select-container .react-select__option {
    background-color: var(--bs-form-select-bg);
}

.react-select-container .react-select__option:hover {
    background-color: var(--bs-gray-300);
}

.react-select-container .react-select__option--is-selected {
    color: var(--bs-form-selected-color);
}

.react-select-container .react-select__indicator-separator {
    background-color: var(--bs-gray-300);
}

.react-select-container .react-select__placeholder,
.react-select-container .react-select__single-value
{
    color: var(--bs-form-select-color);
}

.ck-body-wrapper {
    z-index: 100000000;
    position: relative;
}

body  {
    --ck-custom-background: var(--bs-form-select-bg);
    --ck-custom-foreground: var(--bs-form-select-color);
    --ck-custom-border: var(--bs-form-select-border-color);
    --ck-color-focus-outer-shadow: var(--bs-form-select-border-color);

    --ck-focus-outer-shadow: none;

    --ck-custom-white: var(--bs-form-select-bg);

    /* Overrides the border radius setting in the theme. */
    --ck-border-radius: 4px;

    /* -- Overrides generic colors. ------------------------------------------------------------- */

    --ck-color-base-foreground: var(--ck-custom-background);
    --ck-color-base-border: var(--bs-form-select-border-color);
    --ck-focus-ring: 1px solid var(--ck-color-focus-border);

    --ck-color-focus-border: var(--bs-form-select-border-color);
    --ck-color-text: var(--bs-form-select-text);
    /*
    --ck-color-shadow-drop: hsla(0, 0%, 0%, 0.2);
    --ck-color-shadow-inner: hsla(0, 0%, 0%, 0.1);
*/
    --ck-color-base-active: var(--ck-custom-background);
    --ck-color-base-active-focus: var(--ck-custom-background);
    --ck-color-base-background: var(--ck-custom-background);


    /* -- Overrides the default .ck-button class colors. ---------------------------------------- */

    --ck-color-button-default-background: var(--ck-custom-background);
    --ck-color-button-default-hover-background: var(--ck-custom-border);
    --ck-color-button-default-active-background: var(--ck-custom-border);
    --ck-color-button-default-active-shadow: var(--ck-custom-border);
    --ck-color-button-default-disabled-background: var(--ck-custom-background);

    --ck-color-button-on-background: var(--ck-color-focus-border);
    --ck-color-button-on-hover-background: var(--ck-custom-border);
    --ck-color-button-on-active-background: var(--ck-custom-border);
    --ck-color-button-on-active-shadow: var(--ck-custom-border);
    --ck-color-button-on-disabled-background: var(--ck-custom-foreground);
/*
    --ck-color-button-action-background: hsl(168, 76%, 42%);
    --ck-color-button-action-hover-background: hsl(168, 76%, 38%);
    --ck-color-button-action-active-background: hsl(168, 76%, 36%);
    --ck-color-button-action-active-shadow: hsl(168, 75%, 34%);
    --ck-color-button-action-disabled-background: hsl(168, 76%, 42%);
*/
    --ck-color-button-action-text: var(--ck-custom-white);

    --ck-color-button-save: hsl(120, 100%, 46%);
    --ck-color-button-cancel: hsl(15, 100%, 56%);

    /* -- Overrides the default .ck-dropdown class colors. -------------------------------------- */

    --ck-color-dropdown-panel-background: var(--ck-custom-background);
    --ck-color-dropdown-panel-border: var(--ck-custom-border);

    /* -- Overrides the default .ck-splitbutton class colors. ----------------------------------- */

    --ck-color-split-button-hover-background: var(--ck-color-button-default-hover-background);
    --ck-color-split-button-hover-border: var(--ck-custom-foreground);

    /* -- Overrides the default .ck-input class colors. ----------------------------------------- */

    --ck-color-input-background: var(--ck-custom-background);
    /*
    --ck-color-input-border: hsl(257, 3%, 43%);
    --ck-color-input-text: hsl(0, 0%, 98%);
    --ck-color-input-disabled-background: hsl(255, 4%, 21%);
    --ck-color-input-disabled-border: hsl(250, 3%, 38%);
    --ck-color-input-disabled-text: hsl(0, 0%, 78%);
*/
    /* -- Overrides the default .ck-labeled-field-view class colors. ---------------------------- */

    --ck-color-labeled-field-label-background: var(--ck-custom-background);

    /* -- Overrides the default .ck-list class colors. ------------------------------------------ */

    --ck-color-list-background: var(--ck-custom-background);
    --ck-color-list-button-hover-background: var(--bs-gray-300);
    --ck-color-list-button-on-background: var(--ck-color-base-active);
    --ck-color-list-button-on-background-focus: var(--ck-color-base-active-focus);
    --ck-color-list-button-on-text: var(--bs-form-select-color);

    --ck-color-panel-background: var(--ck-custom-background);
    --ck-color-panel-border: var(--ck-custom-border);

    --ck-color-toolbar-background: var(--ck-custom-background);
    --ck-color-toolbar-border: var(--ck-custom-border);
/*
    --ck-color-tooltip-background: hsl(252, 7%, 14%);
    --ck-color-tooltip-text: hsl(0, 0%, 93%);

    --ck-color-image-caption-background: hsl(0, 0%, 97%);
    --ck-color-image-caption-text: hsl(0, 0%, 20%);

    --ck-color-widget-blurred-border: hsl(0, 0%, 87%);
    --ck-color-widget-hover-border: hsl(43, 100%, 68%);
    --ck-color-widget-editable-focus-background: var(--ck-custom-white);

    --ck-color-link-default: hsl(190, 100%, 75%);
*/
}`, "",{"version":3,"sources":["webpack://./node_modules/react-admin-base-bootstrap/assets/main.css"],"names":[],"mappings":";AAKA,iBAAiB;;AAIjB;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;CACD,YAAY;EACX;;EAEA;CACD,oBAAoB;EACnB;;EAEA;CACD,WAAW;EACV;;EAEA;CACD,mBAAmB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,KAAK;EACL,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,6CAA6C;AAC/C;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAEhB,aAAa;IAEb,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;;IAErB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,aAAa;IAEb,sBAAsB;IAEtB,aAAa;IAEb,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB;AACJ;;AAEA;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAElB,aAAa;IACb;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,+CAA+C;IAC/C;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,oBAAoB;IAEpB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,+CAA+C;IAC/C;AACJ;;AAEA;IAEI,oBAAoB;IAEpB,cAAc;IAEd,uBAAuB;IAEvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,+CAA+C;IAC/C;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QAEI,YAAY;QAEZ,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;QAChB,8CAA8C;QAC9C;IACJ;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QAEI,YAAY;QAEZ,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;QAChB,8CAA8C;QAC9C;IACJ;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QAEI,YAAY;QAEZ,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;QAChB,8CAA8C;QAC9C;IACJ;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QAEI,YAAY;QAEZ,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;QAChB,8CAA8C;QAC9C;IACJ;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,8CAA8C;QAC9C,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,8CAA8C;QAC9C,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,8CAA8C;QAC9C,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,8CAA8C;QAC9C,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QAEI,aAAa;QACb,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QAEI,2BAA2B;QAC3B,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;;IAEA;QAEI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QAEI,aAAa;QACb,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QAEI,2BAA2B;QAC3B,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;;IAEA;QAEI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QAEI,aAAa;QACb,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QAEI,2BAA2B;QAC3B,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;;IAEA;QAEI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QAEI,aAAa;QACb,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QAEI,2BAA2B;QAC3B,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;;IAEA;QAEI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,0CAA0C;IAC1C,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0CAA0C;IAC1C,oDAAoD;AACxD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;IAChD,mDAAmD;IACnD,sDAAsD;IACtD,iEAAiE;;IAEjE,6BAA6B;;IAE7B,2CAA2C;;IAE3C,sDAAsD;IACtD,uBAAuB;;IAEvB,+FAA+F;;IAE/F,uDAAuD;IACvD,0DAA0D;IAC1D,uDAAuD;;IAEvD,2DAA2D;IAC3D,2CAA2C;IAC3C;;;CAGH;IACG,mDAAmD;IACnD,yDAAyD;IACzD,uDAAuD;;;IAGvD,+FAA+F;;IAE/F,iEAAiE;IACjE,mEAAmE;IACnE,oEAAoE;IACpE,gEAAgE;IAChE,0EAA0E;;IAE1E,6DAA6D;IAC7D,8DAA8D;IAC9D,+DAA+D;IAC/D,2DAA2D;IAC3D,qEAAqE;AACzE;;;;;;CAMC;IACG,qDAAqD;;IAErD,2CAA2C;IAC3C,4CAA4C;;IAE5C,+FAA+F;;IAE/F,iEAAiE;IACjE,yDAAyD;;IAEzD,+FAA+F;;IAE/F,yFAAyF;IACzF,iEAAiE;;IAEjE,+FAA+F;;IAE/F,wDAAwD;IACxD;;;;;;CAMH;IACG,+FAA+F;;IAE/F,sEAAsE;;IAEtE,+FAA+F;;IAE/F,uDAAuD;IACvD,2DAA2D;IAC3D,iEAAiE;IACjE,6EAA6E;IAC7E,2DAA2D;;IAE3D,wDAAwD;IACxD,gDAAgD;;IAEhD,0DAA0D;IAC1D,kDAAkD;AACtD;;;;;;;;;;;;CAYC;AACD","sourcesContent":["\n@import \"~nprogress/nprogress.css\";\n@import \"~sweetalert2/dist/sweetalert2.css\";\n@import \"~@fortawesome/fontawesome-free/css/all.min.css\";\n\n/* Image Picker */\n@import url('~tingle.js/dist/tingle.css');\n@import url('~cropperjs/dist/cropper.css');\n\n.password-str-bar ~ .invalid-feedback {\n  margin-top: -20px;\n}\n\n.tingle-modal--visible {\n  z-index: 10000;\n}\n\n@media (max-width: 540px) {\n  .tingle-modal-box__footer .tingle-btn.tingle-btn--danger {\n\tdisplay:none;\n  }\n  \n  .tingle-modal-box__content {\n\tpadding: 1.5rem 3rem;\n  }\n\n  .tingle-modal-box {\n\twidth: 100%;\n  }\n\n  .price_in {\n\tmargin-bottom: 24px;\n  }\n}\n\n.tingle-modal.tingle-modal--visible {\n  display: flex;\n  flex-direction: column;\n}\n\n.tingle-modal-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.tingle-modal-box__content {\n  flex: 1;\n  position: relative;\n}\n\n.tingle-modal-box__content > div {\n  position: absolute;\n  left:0;\n  right:0;\n  top:0;\n  bottom:0;\n}\n\n.tingle-modal--overflow {\n  overflow-y: hidden !important;\n  padding-top: 0 !important;\n}\n\n.tingle-modal-box__footer {\n  text-align: center;\n}\n\n.back-btn-shown {\n  position: fixed;\n  bottom: 10px;\n  right: 10px;\n  width: 30px;\n  height: 30px;\n  background-color: black;\n  border: 1px solid white;\n  box-shadow: 0 10px 30px rgba(82, 85, 90, 0.2);\n  color: white;\n  text-align: center;\n  cursor: pointer;\n  line-height: 25px;\n  font-size: 20px;\n}\n\n.back-btn-shown span {\n  display: none;\n}\n\n.back-btn-shown:hover span {\n  position: absolute;\n  top: 0;\n  right: 35px;\n  width: 74px;\n  margin-left: -37px;\n  display: block;\n  background-color: black;\n  color: white;\n  font-size: 12px;\n  border: 1px solid black;\n  box-shadow: 0 10px 40px rgba(82, 85, 90, 0.2);\n}\n\n\n.step {\n    position: relative;\n    list-style: none;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-right: calc(1.5rem / -2);\n    margin-left: calc(1.5rem / -2)\n}\n\n.step.step-dashed .step-icon::after {\n    border-left-style: dashed\n}\n\n.step-icon-border {\n    border: .125rem solid rgba(231,234,243,.7)\n}\n\n.step-title {\n    display: block;\n    /*color: #1e2022;*/\n    color: var(--bs-dark);\n    \n    font-weight: 600\n}\n\n.step-text:last-child {\n    color: #677788;\n    margin-bottom: 0\n}\n\n.step-border-last-0 .step-item:last-child .step-icon::after {\n    display: none\n}\n\n.step .step-item {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n    padding-right: .75rem;\n    padding-left: .75rem;\n    margin-bottom: 2.25rem\n}\n\n.step-item-between .step-item:last-child {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto\n}\n\n.step .step-content-wrapper {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%\n}\n\n.step .step-content {\n    -ms-flex: 1;\n    flex: 1\n}\n\n.step-item.collapse:not(.show) {\n    display: none\n}\n\n.step-item .step-title-description {\n    display: none\n}\n\n.step-item.focus .step-title-description {\n    display: block\n}\n\n.step .step-avatar {\n    font-size: .875rem;\n    font-weight: 600;\n    width: 2.625rem;\n    height: 2.625rem;\n    border-radius: 50%;\n    margin-right: 1rem\n}\n\n.step .step-avatar-img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 50%\n}\n\n.step .step-avatar::after {\n    position: absolute;\n    top: 3.375rem;\n    left: 1.3125rem;\n    height: calc(100% - 1.875rem);\n    border-left: .125rem solid rgba(231,234,243,.7);\n    content: \"\"\n}\n\n.step-avatar-xs .step-avatar,.step-avatar-xs.step-avatar {\n    font-size: .65625rem;\n    width: 1.53125rem;\n    height: 1.53125rem\n}\n\n.step-avatar-xs .step-avatar::after,.step-avatar-xs.step-avatar::after {\n    top: 2.28125rem;\n    left: .70312rem;\n    width: 1.625rem;\n    height: calc(100% - .78125rem)\n}\n\n.step-avatar-xs .step-divider::after {\n    left: .76562rem\n}\n\n.step-avatar-sm .step-avatar,.step-avatar-sm.step-avatar {\n    font-size: .875rem;\n    width: 2.40625rem;\n    height: 2.40625rem\n}\n\n.step-avatar-sm .step-avatar::after,.step-avatar-sm.step-avatar::after {\n    top: 3.15625rem;\n    left: 1.14062rem;\n    width: 1.625rem;\n    height: calc(100% - 1.65625rem)\n}\n\n.step-avatar-sm .step-divider::after {\n    left: 1.20312rem\n}\n\n.step-avatar-lg .step-avatar,.step-avatar-lg.step-avatar {\n    font-size: 1rem;\n    width: 4.8125rem;\n    height: 4.8125rem\n}\n\n.step-avatar-lg .step-avatar::after,.step-avatar-lg.step-avatar::after {\n    top: 5.5625rem;\n    left: 2.34375rem;\n    width: 1.625rem;\n    height: calc(100% - 4.0625rem)\n}\n\n.step-avatar-lg .step-divider::after {\n    left: 2.40625rem\n}\n\n.step-divider {\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -ms-flex-align: center;\n    align-items: center;\n    text-transform: uppercase;\n    height: 1rem;\n    font-size: .71094rem;\n    font-weight: 600\n}\n\n.step-divider::after {\n    position: absolute;\n    top: 1.75rem;\n    left: 1.3125rem;\n    height: calc(100% - .25rem);\n    border-left: .125rem solid rgba(231,234,243,.7);\n    content: \"\"\n}\n\n.step .step-icon {\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -ms-flex-align: center;\n    align-items: center;\n    font-size: .875rem;\n    font-weight: 600;\n    width: 2.625rem;\n    height: 2.625rem;\n    border-radius: 50%;\n    margin-right: 1rem\n}\n\n.step .step-icon::after {\n    position: absolute;\n    top: 3.375rem;\n    left: 1.3125rem;\n    height: calc(100% - 1.875rem);\n    border-left: .125rem solid rgba(231,234,243,.7);\n    content: \"\"\n}\n\n.step .step-icon-pseudo::before {\n    display: block;\n    width: .25rem;\n    height: .25rem;\n    background-color: #97a4af;\n    border-radius: 50%;\n    content: \"\"\n}\n\n.step-icon-xs .step-icon,.step-icon-xs.step-icon {\n    font-size: .65625rem;\n    width: 1.53125rem;\n    height: 1.53125rem\n}\n\n.step-icon-xs .step-icon::after,.step-icon-xs.step-icon::after {\n    top: 2.28125rem;\n    left: .70312rem;\n    width: 1.625rem;\n    height: calc(100% - .78125rem)\n}\n\n.step-icon-xs .step-divider::after {\n    left: .76562rem\n}\n\n.step-icon-sm .step-icon,.step-icon-sm.step-icon {\n    font-size: .875rem;\n    width: 2.40625rem;\n    height: 2.40625rem\n}\n\n.step-icon-sm .step-icon::after,.step-icon-sm.step-icon::after {\n    top: 3.15625rem;\n    left: 1.14062rem;\n    width: 1.625rem;\n    height: calc(100% - 1.65625rem)\n}\n\n.step-icon-sm .step-divider::after {\n    left: 1.20312rem\n}\n\n.step-icon-lg .step-icon,.step-icon-lg.step-icon {\n    font-size: 1rem;\n    width: 4.8125rem;\n    height: 4.8125rem\n}\n\n.step-icon-lg .step-icon::after,.step-icon-lg.step-icon::after {\n    top: 5.5625rem;\n    left: 2.34375rem;\n    width: 1.625rem;\n    height: calc(100% - 4.0625rem)\n}\n\n.step-icon-lg .step-divider::after {\n    left: 2.40625rem\n}\n\n@media (min-width: 576px) {\n    .step-sm.step-dashed .step-icon::after {\n        border-left:none;\n        border-top-style: dashed\n    }\n\n    .step-sm .step-item {\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        -ms-flex: 1;\n        flex: 1;\n        margin-bottom: 0\n    }\n\n    .step-sm:not(.step-inline) .step-content-wrapper {\n        display: block\n    }\n\n    .step-sm .step-icon {\n        margin-bottom: 1rem\n    }\n\n    .step-sm .step-icon::after {\n        top: 1.3125rem;\n        left: 4.125rem;\n        width: calc(100% - 4.125rem);\n        height: 1.625rem;\n        border-top: .125rem solid rgba(231,234,243,.7);\n        border-left: none\n    }\n\n    .step-sm .step-icon.step-icon-xs::after,.step-sm.step-icon-xs .step-icon::after {\n        top: .76562rem;\n        left: 3.03125rem;\n        width: calc(100% - 3.03125rem)\n    }\n\n    .step-sm .step-icon.step-icon-sm::after,.step-sm.step-icon-sm .step-icon::after {\n        top: 1.20312rem;\n        left: 3.90625rem;\n        width: calc(100% - 3.90625rem)\n    }\n\n    .step-sm .step-icon.step-icon-lg::after,.step-sm.step-icon-lg .step-icon::after {\n        top: 2.40625rem;\n        left: 6.3125rem;\n        width: calc(100% - 6.3125rem)\n    }\n}\n\n@media (min-width: 768px) {\n    .step-md.step-dashed .step-icon::after {\n        border-left:none;\n        border-top-style: dashed\n    }\n\n    .step-md .step-item {\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        -ms-flex: 1;\n        flex: 1;\n        margin-bottom: 0\n    }\n\n    .step-md:not(.step-inline) .step-content-wrapper {\n        display: block\n    }\n\n    .step-md .step-icon {\n        margin-bottom: 1rem\n    }\n\n    .step-md .step-icon::after {\n        top: 1.3125rem;\n        left: 4.125rem;\n        width: calc(100% - 4.125rem);\n        height: 1.625rem;\n        border-top: .125rem solid rgba(231,234,243,.7);\n        border-left: none\n    }\n\n    .step-md .step-icon.step-icon-xs::after,.step-md.step-icon-xs .step-icon::after {\n        top: .76562rem;\n        left: 3.03125rem;\n        width: calc(100% - 3.03125rem)\n    }\n\n    .step-md .step-icon.step-icon-sm::after,.step-md.step-icon-sm .step-icon::after {\n        top: 1.20312rem;\n        left: 3.90625rem;\n        width: calc(100% - 3.90625rem)\n    }\n\n    .step-md .step-icon.step-icon-lg::after,.step-md.step-icon-lg .step-icon::after {\n        top: 2.40625rem;\n        left: 6.3125rem;\n        width: calc(100% - 6.3125rem)\n    }\n}\n\n@media (min-width: 992px) {\n    .step-lg.step-dashed .step-icon::after {\n        border-left:none;\n        border-top-style: dashed\n    }\n\n    .step-lg .step-item {\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        -ms-flex: 1;\n        flex: 1;\n        margin-bottom: 0\n    }\n\n    .step-lg:not(.step-inline) .step-content-wrapper {\n        display: block\n    }\n\n    .step-lg .step-icon {\n        margin-bottom: 1rem\n    }\n\n    .step-lg .step-icon::after {\n        top: 1.3125rem;\n        left: 4.125rem;\n        width: calc(100% - 4.125rem);\n        height: 1.625rem;\n        border-top: .125rem solid rgba(231,234,243,.7);\n        border-left: none\n    }\n\n    .step-lg .step-icon.step-icon-xs::after,.step-lg.step-icon-xs .step-icon::after {\n        top: .76562rem;\n        left: 3.03125rem;\n        width: calc(100% - 3.03125rem)\n    }\n\n    .step-lg .step-icon.step-icon-sm::after,.step-lg.step-icon-sm .step-icon::after {\n        top: 1.20312rem;\n        left: 3.90625rem;\n        width: calc(100% - 3.90625rem)\n    }\n\n    .step-lg .step-icon.step-icon-lg::after,.step-lg.step-icon-lg .step-icon::after {\n        top: 2.40625rem;\n        left: 6.3125rem;\n        width: calc(100% - 6.3125rem)\n    }\n}\n\n@media (min-width: 1200px) {\n    .step-xl.step-dashed .step-icon::after {\n        border-left:none;\n        border-top-style: dashed\n    }\n\n    .step-xl .step-item {\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        -ms-flex: 1;\n        flex: 1;\n        margin-bottom: 0\n    }\n\n    .step-xl:not(.step-inline) .step-content-wrapper {\n        display: block\n    }\n\n    .step-xl .step-icon {\n        margin-bottom: 1rem\n    }\n\n    .step-xl .step-icon::after {\n        top: 1.3125rem;\n        left: 4.125rem;\n        width: calc(100% - 4.125rem);\n        height: 1.625rem;\n        border-top: .125rem solid rgba(231,234,243,.7);\n        border-left: none\n    }\n\n    .step-xl .step-icon.step-icon-xs::after,.step-xl.step-icon-xs .step-icon::after {\n        top: .76562rem;\n        left: 3.03125rem;\n        width: calc(100% - 3.03125rem)\n    }\n\n    .step-xl .step-icon.step-icon-sm::after,.step-xl.step-icon-sm .step-icon::after {\n        top: 1.20312rem;\n        left: 3.90625rem;\n        width: calc(100% - 3.90625rem)\n    }\n\n    .step-xl .step-icon.step-icon-lg::after,.step-xl.step-icon-lg .step-icon::after {\n        top: 2.40625rem;\n        left: 6.3125rem;\n        width: calc(100% - 6.3125rem)\n    }\n}\n\n@media (min-width: 576px) {\n    .step-sm.step-centered {\n        text-align:center\n    }\n\n    .step-sm.step-centered .step-item:last-child .step-icon::after {\n        display: none\n    }\n\n    .step-sm.step-centered .step-icon {\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .step-sm.step-centered .step-icon::after {\n        width: calc(100% - 4.125rem);\n        left: calc(50% + 2.8125rem)\n    }\n\n    .step-sm.step-centered .step-icon.step-icon-xs::after,.step-sm.step-centered.step-icon-xs .step-icon::after {\n        width: calc(100% - 3.03125rem);\n        left: calc(50% + 2.26562rem)\n    }\n\n    .step-sm.step-centered .step-icon.step-icon-sm::after,.step-sm.step-centered.step-icon-sm .step-icon::after {\n        width: calc(100% - 3.90625rem);\n        left: calc(50% + 2.70312rem)\n    }\n\n    .step-sm.step-centered .step-icon.step-icon-lg::after,.step-sm.step-centered.step-icon-lg .step-icon::after {\n        width: calc(100% - 6.3125rem);\n        left: calc(50% + 3.90625rem)\n    }\n}\n\n@media (min-width: 768px) {\n    .step-md.step-centered {\n        text-align:center\n    }\n\n    .step-md.step-centered .step-item:last-child .step-icon::after {\n        display: none\n    }\n\n    .step-md.step-centered .step-icon {\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .step-md.step-centered .step-icon::after {\n        width: calc(100% - 4.125rem);\n        left: calc(50% + 2.8125rem)\n    }\n\n    .step-md.step-centered .step-icon.step-icon-xs::after,.step-md.step-centered.step-icon-xs .step-icon::after {\n        width: calc(100% - 3.03125rem);\n        left: calc(50% + 2.26562rem)\n    }\n\n    .step-md.step-centered .step-icon.step-icon-sm::after,.step-md.step-centered.step-icon-sm .step-icon::after {\n        width: calc(100% - 3.90625rem);\n        left: calc(50% + 2.70312rem)\n    }\n\n    .step-md.step-centered .step-icon.step-icon-lg::after,.step-md.step-centered.step-icon-lg .step-icon::after {\n        width: calc(100% - 6.3125rem);\n        left: calc(50% + 3.90625rem)\n    }\n}\n\n@media (min-width: 992px) {\n    .step-lg.step-centered {\n        text-align:center\n    }\n\n    .step-lg.step-centered .step-item:last-child .step-icon::after {\n        display: none\n    }\n\n    .step-lg.step-centered .step-icon {\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .step-lg.step-centered .step-icon::after {\n        width: calc(100% - 4.125rem);\n        left: calc(50% + 2.8125rem)\n    }\n\n    .step-lg.step-centered .step-icon.step-icon-xs::after,.step-lg.step-centered.step-icon-xs .step-icon::after {\n        width: calc(100% - 3.03125rem);\n        left: calc(50% + 2.26562rem)\n    }\n\n    .step-lg.step-centered .step-icon.step-icon-sm::after,.step-lg.step-centered.step-icon-sm .step-icon::after {\n        width: calc(100% - 3.90625rem);\n        left: calc(50% + 2.70312rem)\n    }\n\n    .step-lg.step-centered .step-icon.step-icon-lg::after,.step-lg.step-centered.step-icon-lg .step-icon::after {\n        width: calc(100% - 6.3125rem);\n        left: calc(50% + 3.90625rem)\n    }\n}\n\n@media (min-width: 992px) {\n    .step-lg.step-centered {\n        text-align:center\n    }\n\n    .step-lg.step-centered .step-item:last-child .step-icon::after {\n        display: none\n    }\n\n    .step-lg.step-centered .step-icon {\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .step-lg.step-centered .step-icon::after {\n        width: calc(100% - 4.125rem);\n        left: calc(50% + 2.8125rem)\n    }\n\n    .step-lg.step-centered .step-icon.step-icon-xs::after,.step-lg.step-centered.step-icon-xs .step-icon::after {\n        width: calc(100% - 3.03125rem);\n        left: calc(50% + 2.26562rem)\n    }\n\n    .step-lg.step-centered .step-icon.step-icon-sm::after,.step-lg.step-centered.step-icon-sm .step-icon::after {\n        width: calc(100% - 3.90625rem);\n        left: calc(50% + 2.70312rem)\n    }\n\n    .step-lg.step-centered .step-icon.step-icon-lg::after,.step-lg.step-centered.step-icon-lg .step-icon::after {\n        width: calc(100% - 6.3125rem);\n        left: calc(50% + 3.90625rem)\n    }\n}\n\n.step .step-is-invalid-icon,.step .step-is-valid-icon {\n    display: none\n}\n\n.step .active .step-icon,.step .active.is-valid .step-icon,.step .visited .step-icon {\n    color: #fff;\n    background-color: var(--bs-primary)\n}\n\n.step .active .step-title,.step .active.is-valid .step-title,.step .visited .step-title {\n    color: var(--bs-primary)\n}\n\n.step .is-valid .step-icon {\n    color: #fff;\n    background-color: #377dff\n}\n\n.step .is-valid .step-title {\n    color: var(--bs-primary)\n}\n\n.step .is-valid .step-is-valid-icon {\n    display: -ms-inline-flexbox;\n    display: inline-flex\n}\n\n.step .is-valid .step-is-default-icon,.step .is-valid .step-is-invalid-icon {\n    display: none\n}\n\n.step .is-invalid .step-icon {\n    color: #fff;\n    background-color: var(--bs-danger)\n}\n\n.step .is-invalid .step-title {\n    color: var(--bs-danger)\n}\n\n.step .is-invalid .step-is-invalid-icon {\n    display: -ms-inline-flexbox;\n    display: inline-flex\n}\n\n.step .is-invalid .step-is-default-icon,.step .is-invalid .step-is-valid-icon {\n    display: none\n}\n\n.step-icon-primary {\n    color: #fff;\n    background-color: #377dff\n}\n\n.step-icon-primary.step-icon-pseudo::before {\n    background-color: #fff\n}\n\n.step-icon-secondary {\n    color: #fff;\n    background-color: #71869d\n}\n\n.step-icon-secondary.step-icon-pseudo::before {\n    background-color: #fff\n}\n\n.step-icon-success {\n    color: #fff;\n    background-color: #00c9a7\n}\n\n.step-icon-success.step-icon-pseudo::before {\n    background-color: #fff\n}\n\n.step-icon-info {\n    color: #fff;\n    background-color: #09a5be\n}\n\n.step-icon-info.step-icon-pseudo::before {\n    background-color: #fff\n}\n\n.step-icon-warning {\n    color: #000;\n    background-color: #f5ca99\n}\n\n.step-icon-warning.step-icon-pseudo::before {\n    background-color: #000\n}\n\n.step-icon-danger {\n    color: #fff;\n    background-color: #ed4c78\n}\n\n.step-icon-danger.step-icon-pseudo::before {\n    background-color: #fff\n}\n\n.step-icon-light {\n    color: #000;\n    background-color: #f9fafc\n}\n\n.step-icon-light.step-icon-pseudo::before {\n    background-color: #000\n}\n\n.step-icon-dark {\n    color: #fff;\n    background-color: #132144\n}\n\n.step-icon-dark.step-icon-pseudo::before {\n    background-color: #fff\n}\n\n.step-icon-soft-primary {\n    color: #377dff;\n    background-color: rgba(55,125,255,.1)\n}\n\n.step-icon-soft-primary.step-icon-pseudo::before {\n    background-color: #377dff\n}\n\n.step-icon-soft-secondary {\n    color: #71869d;\n    background-color: rgba(113,134,157,.1)\n}\n\n.step-icon-soft-secondary.step-icon-pseudo::before {\n    background-color: #71869d\n}\n\n.step-icon-soft-success {\n    color: #00c9a7;\n    background-color: rgba(0,201,167,.1)\n}\n\n.step-icon-soft-success.step-icon-pseudo::before {\n    background-color: #00c9a7\n}\n\n.step-item {\n  cursor: pointer;\n}\n\n.step-icon-soft-info {\n    color: #09a5be;\n    background-color: rgba(9,165,190,.1)\n}\n\n.step-icon-soft-info.step-icon-pseudo::before {\n    background-color: #09a5be\n}\n\n.step-icon-soft-warning {\n    color: #f5ca99;\n    background-color: rgba(245,202,153,.1)\n}\n\n.step-icon-soft-warning.step-icon-pseudo::before {\n    background-color: #f5ca99\n}\n\n.step-icon-soft-danger {\n    color: #ed4c78;\n    background-color: rgba(237,76,120,.1)\n}\n\n.step-icon-soft-danger.step-icon-pseudo::before {\n    background-color: #ed4c78\n}\n\n.step-icon-soft-light {\n    color: #f9fafc;\n    background-color: rgba(249,250,252,.1)\n}\n\n.step-icon-soft-light.step-icon-pseudo::before {\n    background-color: #f9fafc\n}\n\n.step-icon-soft-dark {\n    color: var(--bs-dark);\n    background-color: var(--bs-light)\n}\n\n.step-icon-soft-dark.step-icon-pseudo::before {\n    background-color: var(--bs-light)\n}\n\n.step-inline .step-content-wrapper {\n    -ms-flex-align: center;\n    align-items: center\n}\n\n.step-inline .step-item:last-child .step-title::after {\n    display: none\n}\n\n.step-inline .step-title {\n    display: inline-block\n}\n\n@media (min-width: 576px) {\n    .step-sm.step-inline.step-dashed .step-title::after {\n        border-top-style:dashed\n    }\n\n    .step-sm.step-inline .step-item {\n        overflow: hidden\n    }\n\n    .step-sm.step-inline .step-icon {\n        margin-bottom: 0\n    }\n\n    .step-sm.step-inline .step-icon::after {\n        display: none\n    }\n\n    .step-sm.step-inline .step-title::after {\n        position: absolute;\n        top: 1.3125rem;\n        width: 100%;\n        height: 1.625rem;\n        border-top: .125rem solid rgba(231,234,243,.7);\n        margin-left: 1.5rem;\n        content: \"\"\n    }\n\n    .step-sm.step-inline .step-icon-xs+.step-content .step-title::after,.step-sm.step-inline.step-icon-xs .step-content .step-title::after {\n        top: .76562rem\n    }\n\n    .step-sm.step-inline .step-icon-sm+.step-content .step-title::after,.step-sm.step-inline.step-icon-sm .step-content .step-title::after {\n        top: 1.20312rem\n    }\n\n    .step-sm.step-inline .step-icon-lg+.step-content .step-title::after,.step-sm.step-inline.step-icon-lg .step-content .step-title::after {\n        top: 2.40625rem\n    }\n}\n\n@media (min-width: 768px) {\n    .step-md.step-inline.step-dashed .step-title::after {\n        border-top-style:dashed\n    }\n\n    .step-md.step-inline .step-item {\n        overflow: hidden\n    }\n\n    .step-md.step-inline .step-icon {\n        margin-bottom: 0\n    }\n\n    .step-md.step-inline .step-icon::after {\n        display: none\n    }\n\n    .step-md.step-inline .step-title::after {\n        position: absolute;\n        top: 1.3125rem;\n        width: 100%;\n        height: 1.625rem;\n        border-top: .125rem solid rgba(231,234,243,.7);\n        margin-left: 1.5rem;\n        content: \"\"\n    }\n\n    .step-md.step-inline .step-icon-xs+.step-content .step-title::after,.step-md.step-inline.step-icon-xs .step-content .step-title::after {\n        top: .76562rem\n    }\n\n    .step-md.step-inline .step-icon-sm+.step-content .step-title::after,.step-md.step-inline.step-icon-sm .step-content .step-title::after {\n        top: 1.20312rem\n    }\n\n    .step-md.step-inline .step-icon-lg+.step-content .step-title::after,.step-md.step-inline.step-icon-lg .step-content .step-title::after {\n        top: 2.40625rem\n    }\n}\n\n@media (min-width: 992px) {\n    .step-lg.step-inline.step-dashed .step-title::after {\n        border-top-style:dashed\n    }\n\n    .step-lg.step-inline .step-item {\n        overflow: hidden\n    }\n\n    .step-lg.step-inline .step-icon {\n        margin-bottom: 0\n    }\n\n    .step-lg.step-inline .step-icon::after {\n        display: none\n    }\n\n    .step-lg.step-inline .step-title::after {\n        position: absolute;\n        top: 1.3125rem;\n        width: 100%;\n        height: 1.625rem;\n        border-top: .125rem solid rgba(231,234,243,.7);\n        margin-left: 1.5rem;\n        content: \"\"\n    }\n\n    .step-lg.step-inline .step-icon-xs+.step-content .step-title::after,.step-lg.step-inline.step-icon-xs .step-content .step-title::after {\n        top: .76562rem\n    }\n\n    .step-lg.step-inline .step-icon-sm+.step-content .step-title::after,.step-lg.step-inline.step-icon-sm .step-content .step-title::after {\n        top: 1.20312rem\n    }\n\n    .step-lg.step-inline .step-icon-lg+.step-content .step-title::after,.step-lg.step-inline.step-icon-lg .step-content .step-title::after {\n        top: 2.40625rem\n    }\n}\n\n@media (min-width: 1200px) {\n    .step-xl.step-inline.step-dashed .step-title::after {\n        border-top-style:dashed\n    }\n\n    .step-xl.step-inline .step-item {\n        overflow: hidden\n    }\n\n    .step-xl.step-inline .step-icon {\n        margin-bottom: 0\n    }\n\n    .step-xl.step-inline .step-icon::after {\n        display: none\n    }\n\n    .step-xl.step-inline .step-title::after {\n        position: absolute;\n        top: 1.3125rem;\n        width: 100%;\n        height: 1.625rem;\n        border-top: .125rem solid rgba(231,234,243,.7);\n        margin-left: 1.5rem;\n        content: \"\"\n    }\n\n    .step-xl.step-inline .step-icon-xs+.step-content .step-title::after,.step-xl.step-inline.step-icon-xs .step-content .step-title::after {\n        top: .76562rem\n    }\n\n    .step-xl.step-inline .step-icon-sm+.step-content .step-title::after,.step-xl.step-inline.step-icon-sm .step-content .step-title::after {\n        top: 1.20312rem\n    }\n\n    .step-xl.step-inline .step-icon-lg+.step-content .step-title::after,.step-xl.step-inline.step-icon-lg .step-content .step-title::after {\n        top: 2.40625rem\n    }\n}\n\n@media (min-width: 576px) {\n    .step-timeline-sm {\n        margin-left:0;\n        margin-right: 0\n    }\n\n    .step-timeline-sm .step-item {\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n        padding-left: 0;\n        padding-right: 0;\n        margin-left: 50%\n    }\n\n    .step-timeline-sm .step-item:nth-child(even) {\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n        text-align: right;\n        margin-left: auto;\n        margin-right: 50%\n    }\n\n    .step-timeline-sm .step-item:nth-child(even) .step-content-wrapper {\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse\n    }\n\n    .step-timeline-sm .step-item:nth-child(even) .step-icon {\n        margin-left: 0;\n        margin-right: -1.3125rem\n    }\n\n    .step-timeline-sm .step-item:nth-child(even) .step-icon-xs {\n        margin-right: -.76562rem\n    }\n\n    .step-timeline-sm .step-item:nth-child(even) .step-icon-sm {\n        margin-right: -1.20312rem\n    }\n\n    .step-timeline-sm .step-item:nth-child(even) .step-icon-lg {\n        margin-right: -2.40625rem\n    }\n\n    .step-timeline-sm .step-item:nth-child(even) .step-content {\n        margin-right: 1.5rem\n    }\n\n    .step-timeline-sm .step-icon {\n        margin-left: -1.3125rem\n    }\n\n    .step-timeline-sm .step-icon::after {\n        left: auto;\n        width: auto\n    }\n\n    .step-timeline-sm .step-icon-xs {\n        margin-left: -.76562rem\n    }\n\n    .step-timeline-sm .step-icon-sm {\n        margin-left: -1.20312rem\n    }\n\n    .step-timeline-sm .step-icon-lg {\n        margin-left: -2.40625rem\n    }\n}\n\n@media (min-width: 768px) {\n    .step-timeline-md {\n        margin-left:0;\n        margin-right: 0\n    }\n\n    .step-timeline-md .step-item {\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n        padding-left: 0;\n        padding-right: 0;\n        margin-left: 50%\n    }\n\n    .step-timeline-md .step-item:nth-child(even) {\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n        text-align: right;\n        margin-left: auto;\n        margin-right: 50%\n    }\n\n    .step-timeline-md .step-item:nth-child(even) .step-content-wrapper {\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse\n    }\n\n    .step-timeline-md .step-item:nth-child(even) .step-icon {\n        margin-left: 0;\n        margin-right: -1.3125rem\n    }\n\n    .step-timeline-md .step-item:nth-child(even) .step-icon-xs {\n        margin-right: -.76562rem\n    }\n\n    .step-timeline-md .step-item:nth-child(even) .step-icon-sm {\n        margin-right: -1.20312rem\n    }\n\n    .step-timeline-md .step-item:nth-child(even) .step-icon-lg {\n        margin-right: -2.40625rem\n    }\n\n    .step-timeline-md .step-item:nth-child(even) .step-content {\n        margin-right: 1.5rem\n    }\n\n    .step-timeline-md .step-icon {\n        margin-left: -1.3125rem\n    }\n\n    .step-timeline-md .step-icon::after {\n        left: auto;\n        width: auto\n    }\n\n    .step-timeline-md .step-icon-xs {\n        margin-left: -.76562rem\n    }\n\n    .step-timeline-md .step-icon-sm {\n        margin-left: -1.20312rem\n    }\n\n    .step-timeline-md .step-icon-lg {\n        margin-left: -2.40625rem\n    }\n}\n\n@media (min-width: 992px) {\n    .step-timeline-lg {\n        margin-left:0;\n        margin-right: 0\n    }\n\n    .step-timeline-lg .step-item {\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n        padding-left: 0;\n        padding-right: 0;\n        margin-left: 50%\n    }\n\n    .step-timeline-lg .step-item:nth-child(even) {\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n        text-align: right;\n        margin-left: auto;\n        margin-right: 50%\n    }\n\n    .step-timeline-lg .step-item:nth-child(even) .step-content-wrapper {\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse\n    }\n\n    .step-timeline-lg .step-item:nth-child(even) .step-icon {\n        margin-left: 0;\n        margin-right: -1.3125rem\n    }\n\n    .step-timeline-lg .step-item:nth-child(even) .step-icon-xs {\n        margin-right: -.76562rem\n    }\n\n    .step-timeline-lg .step-item:nth-child(even) .step-icon-sm {\n        margin-right: -1.20312rem\n    }\n\n    .step-timeline-lg .step-item:nth-child(even) .step-icon-lg {\n        margin-right: -2.40625rem\n    }\n\n    .step-timeline-lg .step-item:nth-child(even) .step-content {\n        margin-right: 1.5rem\n    }\n\n    .step-timeline-lg .step-icon {\n        margin-left: -1.3125rem\n    }\n\n    .step-timeline-lg .step-icon::after {\n        left: auto;\n        width: auto\n    }\n\n    .step-timeline-lg .step-icon-xs {\n        margin-left: -.76562rem\n    }\n\n    .step-timeline-lg .step-icon-sm {\n        margin-left: -1.20312rem\n    }\n\n    .step-timeline-lg .step-icon-lg {\n        margin-left: -2.40625rem\n    }\n}\n\n@media (min-width: 1200px) {\n    .step-timeline-xl {\n        margin-left:0;\n        margin-right: 0\n    }\n\n    .step-timeline-xl .step-item {\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n        padding-left: 0;\n        padding-right: 0;\n        margin-left: 50%\n    }\n\n    .step-timeline-xl .step-item:nth-child(even) {\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n        text-align: right;\n        margin-left: auto;\n        margin-right: 50%\n    }\n\n    .step-timeline-xl .step-item:nth-child(even) .step-content-wrapper {\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse\n    }\n\n    .step-timeline-xl .step-item:nth-child(even) .step-icon {\n        margin-left: 0;\n        margin-right: -1.3125rem\n    }\n\n    .step-timeline-xl .step-item:nth-child(even) .step-icon-xs {\n        margin-right: -.76562rem\n    }\n\n    .step-timeline-xl .step-item:nth-child(even) .step-icon-sm {\n        margin-right: -1.20312rem\n    }\n\n    .step-timeline-xl .step-item:nth-child(even) .step-icon-lg {\n        margin-right: -2.40625rem\n    }\n\n    .step-timeline-xl .step-item:nth-child(even) .step-content {\n        margin-right: 1.5rem\n    }\n\n    .step-timeline-xl .step-icon {\n        margin-left: -1.3125rem\n    }\n\n    .step-timeline-xl .step-icon::after {\n        left: auto;\n        width: auto\n    }\n\n    .step-timeline-xl .step-icon-xs {\n        margin-left: -.76562rem\n    }\n\n    .step-timeline-xl .step-icon-sm {\n        margin-left: -1.20312rem\n    }\n\n    .step-timeline-xl .step-icon-lg {\n        margin-left: -2.40625rem\n    }\n}\n\n.react-select-container .react-select__control {\n    background-color: var(--bs-form-select-bg);\n    border-color: var(--bs-form-select-border-color);\n    transition: none;\n}\n\n.react-select-container .react-select__control:hover {\n    border-color: var(--bs-form-select-border-color);\n}\n\n.react-select-container .react-select__menu {\n    background-color: var(--bs-form-select-bg);\n    border: 1px solid var(--bs-form-select-border-color);\n}\n\n.react-select-container .react-select__option {\n    background-color: var(--bs-form-select-bg);\n}\n\n.react-select-container .react-select__option:hover {\n    background-color: var(--bs-gray-300);\n}\n\n.react-select-container .react-select__option--is-selected {\n    color: var(--bs-form-selected-color);\n}\n\n.react-select-container .react-select__indicator-separator {\n    background-color: var(--bs-gray-300);\n}\n\n.react-select-container .react-select__placeholder,\n.react-select-container .react-select__single-value\n{\n    color: var(--bs-form-select-color);\n}\n\n.ck-body-wrapper {\n    z-index: 100000000;\n    position: relative;\n}\n\nbody  {\n    --ck-custom-background: var(--bs-form-select-bg);\n    --ck-custom-foreground: var(--bs-form-select-color);\n    --ck-custom-border: var(--bs-form-select-border-color);\n    --ck-color-focus-outer-shadow: var(--bs-form-select-border-color);\n\n    --ck-focus-outer-shadow: none;\n\n    --ck-custom-white: var(--bs-form-select-bg);\n\n    /* Overrides the border radius setting in the theme. */\n    --ck-border-radius: 4px;\n\n    /* -- Overrides generic colors. ------------------------------------------------------------- */\n\n    --ck-color-base-foreground: var(--ck-custom-background);\n    --ck-color-base-border: var(--bs-form-select-border-color);\n    --ck-focus-ring: 1px solid var(--ck-color-focus-border);\n\n    --ck-color-focus-border: var(--bs-form-select-border-color);\n    --ck-color-text: var(--bs-form-select-text);\n    /*\n    --ck-color-shadow-drop: hsla(0, 0%, 0%, 0.2);\n    --ck-color-shadow-inner: hsla(0, 0%, 0%, 0.1);\n*/\n    --ck-color-base-active: var(--ck-custom-background);\n    --ck-color-base-active-focus: var(--ck-custom-background);\n    --ck-color-base-background: var(--ck-custom-background);\n\n\n    /* -- Overrides the default .ck-button class colors. ---------------------------------------- */\n\n    --ck-color-button-default-background: var(--ck-custom-background);\n    --ck-color-button-default-hover-background: var(--ck-custom-border);\n    --ck-color-button-default-active-background: var(--ck-custom-border);\n    --ck-color-button-default-active-shadow: var(--ck-custom-border);\n    --ck-color-button-default-disabled-background: var(--ck-custom-background);\n\n    --ck-color-button-on-background: var(--ck-color-focus-border);\n    --ck-color-button-on-hover-background: var(--ck-custom-border);\n    --ck-color-button-on-active-background: var(--ck-custom-border);\n    --ck-color-button-on-active-shadow: var(--ck-custom-border);\n    --ck-color-button-on-disabled-background: var(--ck-custom-foreground);\n/*\n    --ck-color-button-action-background: hsl(168, 76%, 42%);\n    --ck-color-button-action-hover-background: hsl(168, 76%, 38%);\n    --ck-color-button-action-active-background: hsl(168, 76%, 36%);\n    --ck-color-button-action-active-shadow: hsl(168, 75%, 34%);\n    --ck-color-button-action-disabled-background: hsl(168, 76%, 42%);\n*/\n    --ck-color-button-action-text: var(--ck-custom-white);\n\n    --ck-color-button-save: hsl(120, 100%, 46%);\n    --ck-color-button-cancel: hsl(15, 100%, 56%);\n\n    /* -- Overrides the default .ck-dropdown class colors. -------------------------------------- */\n\n    --ck-color-dropdown-panel-background: var(--ck-custom-background);\n    --ck-color-dropdown-panel-border: var(--ck-custom-border);\n\n    /* -- Overrides the default .ck-splitbutton class colors. ----------------------------------- */\n\n    --ck-color-split-button-hover-background: var(--ck-color-button-default-hover-background);\n    --ck-color-split-button-hover-border: var(--ck-custom-foreground);\n\n    /* -- Overrides the default .ck-input class colors. ----------------------------------------- */\n\n    --ck-color-input-background: var(--ck-custom-background);\n    /*\n    --ck-color-input-border: hsl(257, 3%, 43%);\n    --ck-color-input-text: hsl(0, 0%, 98%);\n    --ck-color-input-disabled-background: hsl(255, 4%, 21%);\n    --ck-color-input-disabled-border: hsl(250, 3%, 38%);\n    --ck-color-input-disabled-text: hsl(0, 0%, 78%);\n*/\n    /* -- Overrides the default .ck-labeled-field-view class colors. ---------------------------- */\n\n    --ck-color-labeled-field-label-background: var(--ck-custom-background);\n\n    /* -- Overrides the default .ck-list class colors. ------------------------------------------ */\n\n    --ck-color-list-background: var(--ck-custom-background);\n    --ck-color-list-button-hover-background: var(--bs-gray-300);\n    --ck-color-list-button-on-background: var(--ck-color-base-active);\n    --ck-color-list-button-on-background-focus: var(--ck-color-base-active-focus);\n    --ck-color-list-button-on-text: var(--bs-form-select-color);\n\n    --ck-color-panel-background: var(--ck-custom-background);\n    --ck-color-panel-border: var(--ck-custom-border);\n\n    --ck-color-toolbar-background: var(--ck-custom-background);\n    --ck-color-toolbar-border: var(--ck-custom-border);\n/*\n    --ck-color-tooltip-background: hsl(252, 7%, 14%);\n    --ck-color-tooltip-text: hsl(0, 0%, 93%);\n\n    --ck-color-image-caption-background: hsl(0, 0%, 97%);\n    --ck-color-image-caption-text: hsl(0, 0%, 20%);\n\n    --ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n    --ck-color-widget-hover-border: hsl(43, 100%, 68%);\n    --ck-color-widget-editable-focus-background: var(--ck-custom-white);\n\n    --ck-color-link-default: hsl(190, 100%, 75%);\n*/\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
